import logo from './logo-inovacao.png'
import axios from "axios";

import {useState} from 'react'
import { Link, useNavigate } from 'react-router-dom';
import {APIURL} from './config'

function Login() {

    const navigate = useNavigate()

    const [email, setEmail] = useState()
    const [password, setPassword] = useState()

    const  doLogin = async (e) => {
        e.preventDefault()
        try {
            const res = await axios.post(`${APIURL}/Account/Login`, {Login: email, Password: password})
            if (res.data.Token) {
                sessionStorage.setItem("tokeninovacao", res.data.Token);
                sessionStorage.setItem("nomeusuario", res.data.Name);
                sessionStorage.setItem("tipousuario", res.data.Type);
                sessionStorage.setItem("codigoempresa", res.data.Id_Company);
                sessionStorage.setItem("codigousuario", res.data.Id);
                navigate('/home')
            } else {
                alert(res.data.Description)
            }
        }
        catch(err){
            alert("Erro" + err)
        }

    }


  return (
    <div className="container vh-100 d-flex justify-content-center align-items-center">
        <div className="row w-100 d-flex justify-content-center align-items-center p-2">
            <div className="col-12 col-md-4 d-flex flex-column align-items-center bg-white p-5 shadow-sm">
                <img src={logo} alt="logo" style={{height:120, width:120,}} />

                <h2>Bem-vindo ao SUITI</h2>
                
                <p>Faça login abaixo:</p>
                <form onSubmit={(e)=> doLogin(e)} className="w-100" >
                    <div className="form-group mb-3">
                        <input type="text" className="form-control" placeholder="Email" required="" onChange={(e)=> setEmail(e.target.value)}/>
                    </div>
                    <div className="form-group mb-3">
                        <input type="password" className="form-control" placeholder="Senha" required="" onChange={(e)=> setPassword(e.target.value)} />
                    </div>
                    <button type="submit" className="btn btn-success w-100">LOGIN</button>

                    <p className="small mb-0">Esqueceu a senha?</p>
                    <p className="text-muted text-center small mb-0 mt-5">Não tem uma conta?</p>
                    <Link to="/register"><button className="btn btn-outline-secondary w-100" >REGISTRO</button></Link>
                </form>
            
             </div>
            
        </div>
    </div>
  );
}

export default Login;